'use strict'
module.exports = {
  count: 1,
  airport: ['FRA', 'DUS', 'TXL', 'SXF', 'HAM', 'MUC'],
  passengers: [
    {
      type: 'ADT'
    },
    {
      type: 'ADT'
    }
  ],
  destinationToSearch: {
    city: [],
    region: [],
    regiongroup: []
  },
  maxPricePerPerson: 3000,
  durationMin: 6,
  durationMax: 7,
  minHotelCategory: 3,
  minBoardType: 'NoBoard',
  minHotelRecommendation: 80
}
